type showGuidHelperProps = {
    guidData?: any;
    routePath: string;
    extraParams?: any;
    showDashboardGuide?: boolean;
};

function showGuidHelper({guidData, routePath, showDashboardGuide}: showGuidHelperProps) {
    let _find = guidData?.find((item: { key: string }) => item.key === routePath);
    if (routePath === "/dashboard" && showDashboardGuide) {
        return {
            isShow: false,
        };
    } else if (_find) {
        return {
            isShow: true,
            item: _find.items[0],
        };
    } else {
        return {
            isShow: false,
        };
    }
}

export default showGuidHelper;
